import React from 'react';
import * as constants from './Constants'
import {ShoppingCart} from '../views/ShoppingCart'
import {IntroVideo} from '../views/IntroVideo'
import {VirtualRoom} from '../views/VirtualRoom'
import {VirtualTryOn} from '../views/VirtualTryOn'
import {SubRoom} from '../views/SubRoom'
import {RevisedLayout} from '../views/RevisedLayout'
import {LandscapeMode, LoadingScreen} from './StatusScreens'
import {Alert} from './Alerts'
import {VTODisplay} from '../views/VirtualTryOn'

import {goToExternalCheckout, checkStock, getProductStockLevel} from '../components/CartIntegration.js'


import Plausible from 'plausible-tracker'
import { PlausibleState } from './PlausibleState'

const { trackPageview, trackEvent } = Plausible({
  domain: 'kylie-world.netlify.app',
  trackLocalhost: true
}) 


const isChromeIOS = () => {

  const iOS = (navigator.platform === "iPhone" || navigator.platform === "iPad")
  const chrome = navigator.userAgent.includes("CriOS")  
  return (iOS && chrome);
}

const setFaderToBlack = () => {
  const fader = document.getElementById("screenFader");
  if (!fader) return;
  //iOS Chrome does not support CSSAnimations
  if (isChromeIOS()) return;  
  fader.classList.remove("fader-fullscreen-white")
  fader.classList.add("fader-fullscreen-black")
}

const setFaderToWhite = () => {
  const fader = document.getElementById("screenFader");
  if (!fader) return;
  //iOS Chrome does not support CSSAnimations
  if (isChromeIOS()) return;
  fader.classList.remove("fader-fullscreen-black")
  fader.classList.add("fader-fullscreen-white")
}

const fadeScreenIn = () => {

  const fader = document.getElementById("screenFader");
  if (!fader) return;
  //iOS Chrome does not support CSSAnimations
  if (isChromeIOS()) return;

  fader.classList.remove("fader-fadeout");
  fader.classList.remove("fader-fadein");
  fader.classList.add("fader-fadein")

}

const fadeScreenOut = () => {

  const fader = document.getElementById("screenFader");
  if (!fader) return;
  //iOS Chrome does not support CSSAnimations
  if (isChromeIOS()) return;
  
  fader.classList.remove("fader-fadeout");
  fader.classList.remove("fader-fadein");
  fader.classList.add("fader-fadeout")
}

const {useState, useEffect, useRef} = React

// Set this to true, to skip everything and jump direct to VTO.
const DEBUG_VTO = false;

export function ScreenSelector(props) {

  // SceneCounter.  Increment this to force a scene re-render
  const [sceneCounter, /*setSceneCounter*/] = useState(0)  // Comments out to avoid unused-vars warning.  See reset_page function below.
  
  // LoadingScreenReady.  Don't start downloading rest of app until loading screen is in place.
  const [loadingScreenReady, setLoadingScreenReady] = useState(false)

  // The current screen to display in the React app.
  const [currentScreen, setCurrentScreen] = useState(DEBUG_VTO ? constants.REACT_PAGE_VTO : constants.REACT_PAGE_INTRO)  

  // Last screen.  Used to manage "back" navigation from Cart.
  const [lastScreen, setLastScreen] = useState(constants.REACT_PAGE_MAIN)

  const [sceneYRotation, setSceneYRotation] = useState(0)

  // The shade currently selected for the lips in the VTO.
  // This is not a product ID, but can be mapped to one by a lookup in
  // constants.SHADE_PRODUCT_IDS
  // start with shade 1 by default.
  const [selectedShade, setSelectedShade] = useState(0)

  // The current contents of the cart.
  // An array showing the count of each item
  // 2d array, 1st index is the product ID, 2nd index is the shade.
  // for now asume 3 products, 3 shades, may need to adjust down the line.
  // const [cartContents, setCartContents] = useState(constants.PRODUCTS.map(() => 0))
  const [cartContents, setCartContents] = useState(constants.PRODUCTS.map(() => 0))

  const [cartIconStatus, setCartIconStatus] = useState(0)

  // product stock levels.  -1 = "no information"
  const [productStock, setProductStock] = useState(constants.PRODUCTS.map(() => -1))

  const [showAlert, setShowAlert] = useState(constants.ALERT_NONE)

  const [sceneReady, setSceneReady] = useState(DEBUG_VTO ? 1: 0)

  const [startVto, setStartVto] = useState(false)
  const [pauseVto, setPauseVto] = useState(false)

  // use refs to provide access to cart contents & product stock on callbacks.
  const refCartContents = useRef(cartContents)
  const refProductStock = useRef(productStock)  

  const refUrl = useRef(undefined)

  useEffect(() => {

    window.addEventListener('message', function (e) {
      // Get the sent data
      if (!e.data) return
      if (typeof e.data !== "string") return;

      const eventData = JSON.parse(e.data)
      if (eventData.type === "qr-url") {
        refUrl.current = eventData.data
      }
    });
    
  }, []);

  useEffect(() => {
    var head = document.getElementsByTagName('HEAD')[0];

    for (var ii = 0; ii < head.children.length; ii++) {
      const child = head.children[ii];
      if (child.attributes['data-href'] && 
          child.attributes['data-href'].nodeValue === "src/style/aframe.css") {
        head.removeChild(child);
      }
    }
  }, [])

  useEffect(() => {
    // Initially set fader to white (works better doing it here than
    // doing it on the first scene transition).
    setFaderToWhite();
  }, [])

  useEffect(() => {
      window.top.postMessage(JSON.stringify({loadingScreenReady: loadingScreenReady}), '*')
    }, [loadingScreenReady])

  function setAlert(alert) {
    setShowAlert(alert)
  }

  function getIsPortrait() {
  
    const mediaQueryList = window.matchMedia("(orientation: portrait)")
    return (mediaQueryList.matches)
  }

  // for tracking whether in Portrait orientation
  const [isPortrait, setIsPortrait] = useState(getIsPortrait())

  // page3d is an instance variable - so this state can persist into event Handlers.
  const page3d = useRef()

  // Functions to update state.  These are typically passed
  //   to child components, to deliver interactivity.
  function updatePage(index) {

    console.log(`Updating React Page.  New page: ${index}.  Old page: ${currentScreen}`)

    console.log("tracking plausible page view")
    trackPageview()

    PlausibleState.handlePageUpdate(index)

    // store off last screen (useful for back button on cart)
    setLastScreen(currentScreen)

    if (index === constants.REACT_PAGE_MAIN_ALIGN) {            
      
      // No fade in / out on inital display
      setCurrentScreen(index)
    }
    else if (index === constants.REACT_PAGE_VTO_ENTRY)
    {
      // smooth transition, no fade in / out.
      setCurrentScreen(index)
    }
    else {
      setFaderToBlack();
      // fade screen out.    
      fadeScreenOut();

      if (index === constants.REACT_PAGE_FINAL_CHECKOUT ||
          index === constants.REACT_PAGE_EXIT) {
          // exiting app - just get on with it.
          setCurrentScreen(index);
      }
      else {
        // move to new screen and fade screen in once fade completes.
        setTimeout(() => {
          setCurrentScreen(index);
          fadeScreenIn();
        }, 750);        
      }      
    }    
  }

  // Like updatePage, but forces a refresh of the A-Frame scene.
  // specifically used for returning to the scene after the VTO, where scene
  // has to be reset to function correctly.
  /* 4/4/2022 - currently unused after move from 8th wall to Holition for VTO. */
  /*
  function resetPage(index) {

    console.log(`Resetting React Page.  New page: ${index}.  Old page: ${currentScreen}`)

    // move to new screen.
    setCurrentScreen(index)
    
    // force a reset of the AFrame scene.
    setSceneCounter(sceneCounter + 1)
  } */

  function selectShade(shade) {    
    console.log("Selected Shade", shade)
    setSelectedShade(shade)
  }

  function addClearedItemToCart(product) {
    const newCartContents = [...refCartContents.current]
    newCartContents[product] += 1
    setCartContents(newCartContents)

    // add temporary effect to Cart Icon.
    setCartIconStatus(1)
    setTimeout(() => setCartIconStatus(0), 200);
  }

  function itemNotInStock(product) {
    alert('Sorry, item is not in stock')
  }

  function getProductStockLevels() {

    function recordStockLevel(index, level) {
      const newStock = [...refProductStock.current]
      newStock[index] = level
      setProductStock(newStock)

      // we can hit this callback multiple times before refProductStock gets updated in useEffect
      // so keep the current value of refProductStock up to date
      refProductStock.current = newStock
    }

    constants.PRODUCTS.forEach((product, index) => {

      if (index > 0) {
        getProductStockLevel(index)
          .then((level) => recordStockLevel(index, level))
      }
        
    })
  }

  function addItemToCart(product) {
    console.log('Track plausible Add to cart', product)

    const shade = constants.SHADE_PRODUCT_IDS.indexOf(product)
    const timeOnShade = (shade > 0) ? PlausibleState.getTimeOnShade(shade) : 0

    console.log("======Time On Shade: ", timeOnShade)

    trackEvent("Add to Cart", {
        callback: () => console.log("done"),
        props: {
          product: constants.PRODUCTS[product].name,
          productTries: PlausibleState.getNumberProductTries(),
          timeInVTO: PlausibleState.getTimeInVTO(),
          timeOnShade: timeOnShade,
          speed: navigator.connection ? navigator.connection.downlink : undefined
        }
    })

    if (refProductStock.current[product] > refCartContents.current[product]) {
      // local state tells us stock is available
      addClearedItemToCart(product)
    }
    else if (refProductStock.current[product] === -1) {
      // unknown product stock, so generate an API call.
      checkStock(product, refCartContents.current[product] + 1)
      .then(() => addClearedItemToCart(product),
        () => itemNotInStock(product))
    }
    else {
      // product stock level is known, and insufficient
      itemNotInStock(product)
    }
  }

  function removeItemFromCart(product) {
    if (cartContents[product] > 0) {
      const newCartContents = [...refCartContents.current]
      newCartContents[product] -= 1
      setCartContents(newCartContents)
    }
  }

  // This is used in VTO, and adds the currently selected shade to the cart
  function addToCart() {
    // only shades > 0 are real products (0 = no product applied)
    if (selectedShade > 0) {
      addItemToCart(constants.SHADE_PRODUCT_IDS[selectedShade])
    }
  }

  // Takes an event from the A-Frame 3D scene, and acts on it.
  function navigateFromEvent(event) {
    console.log(`Navigating based on clickdata: ${event.detail}`)

    console.log(`track plausible visit room: ${event.detail}`)
    trackEvent("Navigate To Room", {
        callback: () => console.log("done"),
        props: {
          room: event.detail
        }
    })
    
    switch (event.detail) {
      case 'exitDoor':
        updatePage(constants.REACT_PAGE_MAIN)
        setSceneYRotation(0)
        break

      case 'exitDoorMain':
        setAlert(constants.ALERT_EXIT)
        break

      case 'lookClassic':
        updatePage(constants.REACT_PAGE_LOOKS_CLASSIC)        
        break

      case 'lookEyes':
        updatePage(constants.REACT_PAGE_LOOKS_EYES)        
        break

      case 'lookLips':
        updatePage(constants.REACT_PAGE_LOOKS_LIPS)        
        break

      case 'productLips':
        updatePage(constants.REACT_PAGE_LIPS)
        setSceneYRotation(0)
        break

      case 'productEyes':
        updatePage(constants.REACT_PAGE_EYES)
        setSceneYRotation(0)
        break

      case 'productBlush':
        updatePage(constants.REACT_PAGE_BLUSH)
        setSceneYRotation(0)
        break

      case 'productPlump':
        updatePage(constants.REACT_PAGE_PLUMP)
        setSceneYRotation(0)
        break
  
      case 'productPalette':
        updatePage(constants.REACT_PAGE_PALETTE)
        setSceneYRotation(0)
        break

      case 'tryonLips':
        updatePage(constants.REACT_PAGE_VTO_ENTRY)
        setSceneYRotation(0)
        break

      default:
        console.log(`Trying to navigate based on unexpected clickdata: ${event.detail}`)
        break
    }
  }

  function addItemToCartOnPageClick(event) {
    addItemToCart(event.detail)
  }

  function introVideoReady(event) {
    console.log("introvideoready (React Layer)")
    setSceneReady(1)
  }

  
  // Ensure cart contents and product stock reflect latest values.
  // - see: https://reactjs.org/docs/hooks-faq.html#why-am-i-seeing-stale-props-or-state-inside-my-function
  useEffect(() => {
    refCartContents.current = cartContents
    refProductStock.current = productStock
  })

  // register for events we may receive from A-Frame scene
  // second parameter ensures this only runs once, and hence we only detect one event per click
  
  // Disable ES-Lint error complaining about missing dependencies.
  // Intention is for this hook to be only executed on mounting the component for the first time.
  // I don't believe omitting the dependencies causes any problems (and adding them might cause problems).
  // Reference here: https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
  useEffect(() => {
    window.addEventListener('objectClicked', event => navigateFromEvent(event))
    window.addEventListener('addToCart', event => addItemToCartOnPageClick(event))
    // realityready event is firing before  videos are loaded (despite "preload" flag
    // which is supposed to delay scene ready until assets are loaded.
    // use custom introvideoready event instead.
    window.addEventListener('introvideoready', event => introVideoReady(event))
    // error most likely due to incompatible device type.
    // useful for testing on desktop to render in any case & better than leaving a "loading..." screen up.
    // note that in the case of landscape screen layout, the landscape error screen will be overlaid.
    window.addEventListener('realityerror', event => {
      console.log("Hit realityerror, but moving on anyway")
      console.warn("Hit realityerror, but moving on anyway")
      introVideoReady(event)
    })

    window.addEventListener('vtoVideoEnded', event => updatePage(constants.REACT_PAGE_VTO))
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // gather data about stock levels.
  useEffect(() => {
    
    getProductStockLevels()
  }, [])



  const handleResize = () => {
                               setIsPortrait(getIsPortrait())
                             }

  // Disable ES-Lint error complaining about missing dependencies.
  // Intention is for this hook to be only executed on mounting the component for the first time.
  // I don't believe omitting the dependencies causes any problems (and adding them might cause problems).
  // Reference here: https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
  useEffect(() => {
    
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // count number of items in cart
  const itemCount = cartContents.reduce((a, b) => a + b)

  // Main rendering code - display screen based on the currentScreen state.
  // scenePosition = background / foreground.  Probably not needed if we got z-index right for all
  // React elements we want to sit above the screen.
  // But leave for now as it's not causing problems, and we don't want to do a refactor at this point.
  let html
  let scenePosition
  let sceneHtml
  const wrapScene = (sceneCounter % 2)

  switch (currentScreen) {
    case constants.REACT_PAGE_INTRO:
      html = (
        <IntroVideo updatePage = {updatePage}/>
      )
      page3d.current = 'intro'
      scenePosition = 'foreground'
      break

    case constants.REACT_PAGE_MAIN:
    case constants.REACT_PAGE_MAIN_ALIGN:
      // for performance reasons, pause VTO
      if (!pauseVto) {
        setPauseVto(true);
      }

      html = (
        <VirtualRoom
                updatePage = {updatePage}
                setAlert = {setAlert}
                cartIconStatus = {cartIconStatus}
                itemCount = {itemCount}/>
      )
      console.log("screen set to REACT_PAGE_MAIN")

      if (currentScreen === constants.REACT_PAGE_MAIN_ALIGN) {
        page3d.current = 'main-room-align'
      }
      else {
        page3d.current = 'main-room'
      }
      
      scenePosition = 'foreground'
      break

    case constants.REACT_PAGE_LOOKS_CLASSIC:
    case constants.REACT_PAGE_LOOKS_EYES:
    case constants.REACT_PAGE_LOOKS_LIPS:
    case constants.REACT_PAGE_LIPS:
    case constants.REACT_PAGE_EYES:
    case constants.REACT_PAGE_BLUSH:
    case constants.REACT_PAGE_PLUMP:
    case constants.REACT_PAGE_PALETTE:
    case constants.REACT_PAGE_VTO_ENTRY:
      html = (
        <SubRoom
                  updatePage = {updatePage}
                  cartIconStatus = {cartIconStatus}
                  itemCount = {itemCount}/>
      )
      switch (currentScreen) {
        case constants.REACT_PAGE_LOOKS_CLASSIC:
          page3d.current = 'looks-room-classic'
          break
        
        case constants.REACT_PAGE_LOOKS_EYES:
          page3d.current = 'looks-room-eyes'
          break

        case constants.REACT_PAGE_LOOKS_LIPS:
          page3d.current = 'looks-room-lips'
          break

        case constants.REACT_PAGE_LIPS:
          page3d.current = 'lips-room'
          break

        case constants.REACT_PAGE_EYES:
          page3d.current = 'eyes-room'
          break

        case constants.REACT_PAGE_BLUSH:
          page3d.current = 'blush-room'
          break

        case constants.REACT_PAGE_PLUMP:
          page3d.current = 'plump-room'
          break
  
        case constants.REACT_PAGE_PALETTE:
          page3d.current = 'palette-room'
          break

        case constants.REACT_PAGE_VTO_ENTRY:
          page3d.current = 'vto-entry'
          break

        default:
          console.log(`Unknown room: ${currentScreen}`)
          break
      }
      scenePosition = 'foreground'
      break

    case constants.REACT_PAGE_VTO:
      
      if (!startVto) {
        setStartVto(true);
      }
      
      if (pauseVto) {
        setPauseVto(false);
      }
      
      html = (
        <VirtualTryOn
              updatePage = {updatePage}
              selectedShade={selectedShade}
              selectShade={selectShade}
              addToCart = {addToCart}
              cartContents={cartContents}
              cartIconStatus = {cartIconStatus}
              productStock={productStock}/>
      )
      // page3d is unchanged (no VTO)
      // page3d.current = 'vto'
      scenePosition = 'background'
      break

    case constants.REACT_PAGE_CART:
      html = (
        <ShoppingCart
              cartContents = {cartContents}
              addItem = {addItemToCart}
              removeItem = {removeItemFromCart}
              updatePage = {updatePage}
              lastPage={lastScreen}/>
      )

      // Although the 3D scene is not visible on the cart screen
      // we want to continue to render it in the background
      // so that if the user goes back, we don't have to re-initialize
      // the A-Frame scene.

      // page3d is unchanged. 
      scenePosition = 'background'
      break

    case constants.REACT_PAGE_FINAL_CHECKOUT:
      html = (
        <FinalCheckout
              cartContents = {cartContents}
              updatePage = {updatePage}/>
      )
      page3d.current = null
      break

    case constants.REACT_PAGE_EXIT:
      // Send a message to the parent iFrame to redirect to boots homepage.
      window.top.postMessage(JSON.stringify({redirect: "https://www.boots.com"}), '*')
      // If not using iFRames, use...
      // window.location.assign("https://www.boots.com")          
      break

    default:
      html = <h1>We have hit an error: unknown page: {currentScreen}</h1>
      page3d.current = null
      break
  }

  // The "RevisedLayout" component generates a single A-Frame Scene, which is used (with
  // modifications) for all A-Frame content.
  // React will re-render this (completely re-initializing the A-Frame scene) if its position
  // in the hierarchy is changed.  Therefore it must not be a child of the individual page
  // components, but must have its own fixed place in the component hierarchy.
  if (page3d.current) {
    sceneHtml = (
      <RevisedLayout
        page={page3d.current}
        yRotation={sceneYRotation}
        sceneClass={scenePosition}
        updatePage = {updatePage}
        selectedShade={selectedShade}
        selectShade={selectShade}
        addToCart = {addToCart}
        cartContents = {cartContents}
        productStock = {productStock}/>
    )
  } else {
    sceneHtml = ''
  }

  if (!isPortrait) {
    // We are either on desktop, or on a device in landscape mode.
    html = <LandscapeMode
            url = {refUrl.current}/>
    // don't change page3d - allow 3D scene to be in background so we don't have to re-initiate
    // A-Frame.
    // This just masks it.
    scenePosition = 'background'
  }

  // When sceneCounter changes, SceneWrapper er is toggled in/out of the React hierarchy
  // this forces a reload of the A-Frame scene.
  // ** NOTE /4/4/2022 - this functionality is currently unused - was needed with 8th Wall VTO
  //    but with current implementation there are no occasions when we need to refresh the A-Frame scene */
  return (
    <>
      <div id="screenFader"></div>
      <LoadingScreen ready={sceneReady}
                     readyCallback={() => setLoadingScreenReady(true)}/>
      {!loadingScreenReady || 
        <>
          <Alert alert={showAlert}
                itemCount={itemCount}
                setAlert={setAlert}
                updatePage={updatePage}/>
          
          {startVto ?         
            <VTODisplay
                  shade={selectedShade}
                  pause={pauseVto}/> :
            <>
            </>
          }     
          {wrapScene ? 
            <>
              {html}
              {sceneHtml}
            </> :
            <SceneWrapper
              html={html}
              sceneHtml={sceneHtml}>
            </SceneWrapper>
          }
        </>
      }
    </>
  )
}

function FinalCheckout(props) {
  useEffect(() => {
    goToExternalCheckout(props.cartContents)
  })

  return (
    <div className='fullscreen'>
      <div className='cartBackground'></div>  
    </div>    
  )
}

// SceneWrapper is a null component.  Including/removing it is used as a way to force 
// refresh of the A-Frame scene.
function SceneWrapper(props) {
  
  return (
    <>
      {props.html}
      {props.sceneHtml}
    </>
  )
}
